import dayjs from 'dayjs';

export const isSaleToday = (nextSaleStarts: Nullable<string>): boolean => dayjs().day() === dayjs(nextSaleStarts).day();
